import styled from '@emotion/styled';
import {SearchSummary as SearchSummaryUI} from '@travel-frontend/ui-components';

export const SearchSummary = styled(SearchSummaryUI)`
  background-color: transparent;
`;
